import { styles } from "./ModuleLink.css.ts";

/**
 * Displays the workshop module's duration.
 *
 * @param {Object} TimePill - The TimePill component.
 * @param {boolean} duration - Specifies the length of the module (station or procedure)
 * @returns {JSX.Element} A JSX element representing the time pill.
 */
export const ModuleTime = ({ duration }) => {
  if (!duration) return <div style={{ width: "calc(4.5rem + 4px)" }} />;
  return (
    <div className={styles.moduleTime}>
      <div>{duration} min</div>
    </div>
  );
};
